<template>
	<div class="opt_container" :style="layerStyle">
		<head-cont-layer v-bind="propsMap.headCont"/>
		<list-num-layer v-bind="propsMap.listNum"/>
		<move-layer v-bind="propsMap.move"/>
		<edit-layer v-bind="propsMap.edit"/>
		<role-layer v-bind="propsMap.role"/>
		<notice-layer v-bind="propsMap.notice"/>
		<user-layer v-bind="propsMap.user"/>
		<folder-layer v-bind="propsMap.folder"/>
		<week-layer v-bind="propsMap.week"/>
		<mode-layer v-bind="propsMap.mode"/>
	</div>
</template>

<script>
import HeadContLayer from './HeadContLayer.vue';
import ListNumLayer from './ListNumLayer.vue';
import MoveLayer from './MoveLayer.vue';
import EditLayer from './EditLayer.vue';
import RoleLayer from './RoleLayer.vue';
import NoticeLayer from './NoticeLayer.vue';
import UserLayer from './UserLayer.vue';
import FolderLayer from './FolderLayer.vue';
import WeekLayer from './WeekLayer.vue';
import ModeLayer from './ModeLayer.vue';
import {eventBus} from './event-bus.mjs';

export default {
	components: {
		HeadContLayer, ListNumLayer,
		MoveLayer, EditLayer, RoleLayer, NoticeLayer,
		UserLayer, FolderLayer,
		WeekLayer, ModeLayer
	},
	data() {
		return {
			top: 0,
			left: 0,
			
			propsMap: {
				headCont: {},
				listNum: {},
				move: {},
				edit: {},
				role: {},
				notice: {},
				user: {},
				folder: {},
				week: {},
				mode: {}
			}
		};
	},
	computed: {
		layerStyle() {
			return {
				top: this.top > 0 ? `${this.top}px` : 0,
				left: this.left > 0 ? `${this.left}px` : 0
			};
		}
	},
	created() {
		document.body.addEventListener('click', () => {
			eventBus.$emit('close-layer');
		});

		eventBus.$on('open-layer', ({el, layerName, props}) => {
			const {top, left} = el.getBoundingClientRect();
			this.top = document.documentElement.scrollTop + top;
			this.left = left;
			
			this.$set(this.propsMap, layerName, props);
		});
	}
}
</script>
